import { isEmptyHtml, looksLikeHtml, sanitizeHtml } from "../../utils/richText";
import "./RichTextDisplay.css";

/**
 * Safe display of rich-text (or legacy plain-text) content.
 */
export default function RichTextDisplay({ html, emptyLabel = "—" }) {
  if (isEmptyHtml(html)) {
    return <span>{emptyLabel}</span>;
  }

  const raw = String(html);
  if (!looksLikeHtml(raw)) {
    return (
      <span style={{ whiteSpace: "pre-wrap" }}>{raw}</span>
    );
  }

  const clean = sanitizeHtml(raw);
  return (
    <div
      className="ics-rich-text-display"
      style={{ whiteSpace: "normal" }}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
